import "./passingPage.scss";

const PassingPage = () => {
  return <div className="passing-page"></div>;
};

export default PassingPage;
